import _Object$keys from 'babel-runtime/core-js/object/keys';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';

/* eslint-disable max-lines */
import { getTagList } from '@/api/common/index.js';
import { createMaterial } from '@/api/res_store/create';
import { getMaterialInfo } from '@/api/res_store/info';
import { updateMaterialInfo } from '@/api/res_store/update';
import { contrastObj } from '@/utils/index';
import * as api from '@/config/api';
import { v2Host } from '@/config/host';

export default {
  data: function data() {
    var checkLength = function checkLength(rule, value, callback) {
      if (value.length > 50) {
        return callback(new Error('动画标签数量不能超过50'));
      }
      return callback();
    };
    return {
      bLoading: false,
      oInfo: {},
      oTagAnimation: {
        bLoading: true,
        aList: [],
        bIptVisible: false,
        sIptVal: ''
      },
      oTagEffect: {
        bLoading: true,
        aList: [],
        bIptVisible: false,
        sIptVal: ''
      },
      aFileList: [],
      aIconList: [],
      oData: {
        cat1_id: '',
        cat2_id: '',
        name: '',
        tag1_names: [],
        tag2_names: [],
        file_path: '',
        img_file: '',
        ext_config: {},
        image_origin_name: '',
        file_origin_name: ''
      },
      oRule: {
        name: [{ required: true, message: '请填写名称', trigger: 'change' }],
        tag1_names: [{ required: true, message: '请选择动画标签', trigger: 'change' }, { validator: checkLength, trigger: 'change' }],
        cat1_id: [{ required: true, message: '请选择图片类型', trigger: 'change' }, { validator: checkLength, trigger: 'change' }],
        img_file: [{ required: true, message: '请上传预览图片', trigger: 'change' }],
        file_path: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    };
  },

  computed: {
    zipUploadTip: function zipUploadTip() {
      var note = '';
      if (Number(this.oData.cat1_id) === 1) {
        note = '龙骨动画文件格式json + png + dbproj';
      } else if (Number(this.oData.cat1_id) === 2) {
        note = '序列帧动画格式有序png文件';
      } else {
        return '选择图片类型';
      }
      return '\u53EA\u80FD\u4E0A\u4F20zip\u6587\u4EF6\uFF0C\u91CC\u9762\u5FC5\u987B\u5305\u62EC' + note + '\uFF0Czip\u5305\u4E2D\u7684\u6587\u4EF6\u8BF7\u4EE5\u82F1\u6587\u547D\u540D';
    },
    hasEffectTag: function hasEffectTag() {
      var taglist = this.oData.tag1_names;
      var sign = false;
      for (var i in taglist) {
        if (taglist[i] === '特效') {
          sign = true;
          break;
        }
      }
      return sign;
    },

    uploadUrl: {
      get: function get() {
        return v2Host + '/upload/file';
      }
    },
    downloadUrl: {
      get: function get() {
        return api.resStoreDownloadUrl;
      }
    }
  },
  mounted: function mounted() {
    this.fnGetTag1();
    this.fnGetTag2();
    if (this.$route.params.id) {
      this.fnGetInfo();
    }
  },

  methods: {
    // 获取单个详情
    fnGetInfo: function fnGetInfo() {
      var _this = this;

      this.bLoading = true;
      getMaterialInfo({
        id: this.$route.params.id
      }).then(function (res) {
        _this.oInfo = res.data.data.info;
        _this.oInfo.ext_config = JSON.parse(_this.oInfo.ext_config);
        _this.bLoading = false;
        _this.oData.name = _this.oInfo.name;
        _this.oData.cat1_id = Number(_this.oInfo.cat1_id);
        _this.oData.cat2_id = Number(_this.oInfo.cat2_id); // 标识是否选中特效标签
        _this.oInfo.tag1_list && (_this.oData.tag1_names = _this.oInfo.tag1_list.map(function (e) {
          return e.name;
        }));
        _this.oInfo.tag2_list && (_this.oData.tag2_names = _this.oInfo.tag2_list.map(function (e) {
          return e.name;
        }));
        _this.oData.file_path = _this.oInfo.file_url; // info接口文件地址字段为file_url
        _this.oData.img_file = _this.oInfo.image_url;
        _this.oData.image_origin_name = _this.oInfo.image_origin_name;
        _this.oData.file_origin_name = _this.oInfo.file_origin_name;
        // 预览文件地址
        _this.aFileList = [{
          url: _this.oInfo.file_url,
          name: _this.oInfo.file_origin_name
        }];
        _this.aIconList = [{
          url: _this.oInfo.image_url,
          name: _this.oInfo.image_origin_name
        }];
        var self = _this;
        setTimeout(function () {
          if (self.$refs.form) {
            self.$refs.form.clearValidate();
          }
        }, 100);
        var sName = _this.oInfo.name.length > 20 ? _this.oInfo.name.substr(0, 20) + '...' : _this.oInfo.name;
        document.querySelector('.app-breadcrumb .u-breadcrumb-cur').innerHTML = '编辑：' + sName;
      }).catch(function () {
        _this.bLoading = false;
      });
    },
    changeAnimationType: function changeAnimationType(val) {
      this.oData.file_path = '';
      this.$refs.animationFile.clearFiles();
    },

    // 获取获取素材第一标签
    fnGetTag1: function fnGetTag1() {
      var _this2 = this;

      this.oTagAnimation.bLoading = true;
      getTagList({
        type: 8
      }).then(function (res) {
        _this2.oTagAnimation.bLoading = false;
        _this2.oTagAnimation.aList = res.data.data.tags;
      }).catch(function () {});
    },
    fnOnUploadError: function fnOnUploadError() {
      this.$message.warning('文件上传出错！');
    },

    // 获取素材第二标签
    fnGetTag2: function fnGetTag2() {
      var _this3 = this;

      this.oTagEffect.bLoading = true;
      getTagList({
        type: 6
      }).then(function (res) {
        _this3.oTagEffect.bLoading = false;
        _this3.oTagEffect.aList = res.data.data.tags;
      }).catch(function () {});
    },

    // 点击新增标签
    fnShowTag1: function fnShowTag1() {
      var _this4 = this;

      this.oTagAnimation.bIptVisible = true;
      this.$nextTick(function (_) {
        _this4.$refs.styleIpt.$refs.input.focus();
      });
    },
    fnRemoveFile: function fnRemoveFile() {
      this.oData.file_path = '';
    },
    fnRemoveIcon: function fnRemoveIcon() {
      this.oData.img_file = '';
    },
    fnShowTag2: function fnShowTag2() {
      var _this5 = this;

      this.oTagEffect.bIptVisible = true;
      this.$nextTick(function (_) {
        _this5.$refs.animationIpt.$refs.input.focus();
      });
    },

    // 保存标签
    fntag1SaveTag: function fntag1SaveTag() {
      var sVal = this.oTagAnimation.sIptVal.trim();
      if (sVal) {
        if (this.oData.tag1_names.indexOf(sVal) === -1) {
          var aStyle = this.oTagAnimation.aList.map(function (e) {
            return e.name;
          });
          if (aStyle.indexOf(sVal) !== -1) {
            this.$message({
              message: '添加失败，标签已存在',
              type: 'warning'
            });
            this.oTagAnimation.aList.forEach(function (e) {
              if (String(e.name) === String(sVal)) {
                e.class = 's-warn';
              }
            });
          } else {
            this.oData.tag1_names.push(sVal);
          }
        } else {
          this.$message({
            message: '已经存在该标签',
            type: 'warning'
          });
        }
      }
      this.oTagAnimation.bIptVisible = false;
      this.oTagAnimation.sIptVal = '';
    },
    fntag2SaveTag: function fntag2SaveTag() {
      var sVal = this.oTagEffect.sIptVal.trim();
      if (sVal) {
        if (this.oData.tag2_names.indexOf(sVal) === -1) {
          var aStyle = this.oTagEffect.aList.map(function (e) {
            return e.name;
          });
          if (aStyle.indexOf(sVal) !== -1) {
            this.$message({
              message: '添加失败，标签已存在',
              type: 'warning'
            });
            this.oTagEffect.aList.forEach(function (e) {
              if (String(e.name) === String(sVal)) {
                e.class = 's-warn';
              }
            });
          } else {
            this.oData.tag2_names.push(sVal);
          }
        } else {
          this.$message({
            message: '已经存在该标签',
            type: 'warning'
          });
        }
      }
      this.oTagEffect.bIptVisible = false;
      this.oTagEffect.sIptVal = '';
    },

    // 删除标签
    fnCloseTag1: function fnCloseTag1(tag) {
      this.oData.tag1_names.splice(this.oData.tag1_names.indexOf(tag), 1);
    },
    fnCloseTag2: function fnCloseTag2(tag) {
      this.oData.tag2_names.splice(this.oData.tag2_names.indexOf(tag), 1);
    },
    fnChangeFile: function fnChangeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    // 上传模型文件
    fnSuccessFile: function fnSuccessFile(response, file, fileList) {
      var _this6 = this;

      if (response.code === 0) {
        this.oData.file_path = response.data.file_path;
        this.oData.file_origin_name = response.data.origin_name;
        this.$refs.form.validateField('file_path');
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this6.oData.icon_file = '';
          _this6.aFileList = [];
        });
      }
    },
    fnSuccessIcon: function fnSuccessIcon(response, file, fileList) {
      var _this7 = this;

      if (response.code === 0) {
        this.oData.img_file = response.data.file_path;
        this.oData.image_origin_name = response.data.origin_name;
        this.$refs.form.validateField('img_file');
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this7.oData.img_file = '';
          _this7.aIconList = [];
        });
      }
    },
    fnClickList: function fnClickList(file) {
      console.log(file);
      if (file.response && file.response.data && file.response.data.url) {
        window.open(file.response.data.url);
      } else {
        window.open(file.url);
      }
    },
    fnSubmit: function fnSubmit() {
      var _this8 = this;

      var self = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this8.bLoading = true;
          var submitPromist = void 0,
              oData = void 0,
              oInfo = void 0;
          if (_this8.$route.params.id) {
            submitPromist = updateMaterialInfo;
            oData = JSON.parse(_JSON$stringify(_this8.oData));
            oInfo = JSON.parse(_JSON$stringify(_this8.oInfo));
            oInfo.tag1_list && (oInfo.tag1_names = oInfo.tag1_list.map(function (e) {
              return e.name;
            }));
            oInfo.tag2_list && (oInfo.tag2_names = oInfo.tag2_list.map(function (e) {
              return e.name;
            }));
            oInfo.img_file = oInfo.image_url;
            oInfo.file_path = oInfo.file_url;
            oData = contrastObj(oData, oInfo);
            if (_Object$keys(oData).length === 0) {
              _this8.$message({
                message: '没有任何修改',
                type: 'warning'
              });
              _this8.bLoading = false;
              return;
            }
            if (oData.file_path) {
              oData.file_type = 'local';
              oData.file_origin_name = _this8.oData.file_origin_name;
            }
            oData.queryId = _this8.$route.params.id;
            oData.tag1_names && (oData.tag1_names = oData.tag1_names.join());
            oData.tag2_names && (oData.tag2_names = oData.tag2_names.join());
          } else {
            submitPromist = createMaterial;
            oData = JSON.parse(_JSON$stringify(_this8.oData));
            oData.res_type = 3;
            oData.file_type = 'local';
            oData.tag1_names && (oData.tag1_names = oData.tag1_names.join());
            oData.tag2_names && (oData.tag2_names = oData.tag2_names.join());
            oData.ext_config = _JSON$stringify(oData.ext_config);
          }
          // 动画标签删除特效标签提交数据时，清空特效标签内容
          if (oData.tag1_names && !_this8.hasEffectTag) {
            oData.tag2_names = '';
            oData.cat2_id = 0;
          }
          // 带特效标签，需要添加特殊标识
          if (_this8.hasEffectTag) {
            oData.cat2_id = 1;
          }
          submitPromist(oData).then(function (res) {
            self.bLoading = false;
            self.$message({
              message: 'success',
              type: 'success'
            });
            if (_this8.$route.params.id) {
              setTimeout(function () {
                if (location.href.indexOf('edit') !== -1 || location.href.indexOf('add') !== -1) {
                  self.$router.back(-1);
                }
              }, 3000);
            } else {
              setTimeout(function () {
                if (location.href.indexOf('edit') !== -1 || location.href.indexOf('add') !== -1) {
                  self.$router.push({ name: 'repo.itav-material.2d-animation-list' });
                }
              }, 3000);
            }
          }).catch(function () {
            _this8.bLoading = false;
          });
        }
      });
    },
    fnBackBtn: function fnBackBtn() {
      var _this9 = this;

      var h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [h('p', null, '\u786E\u8BA4\u8FD4\u56DE\uFF1F\u82E5\u7EE7\u7EED\uFF0C\u5F53\u524D\u5DF2\u586B\u5199\u7684\u5185\u5BB9\u5747\u4F1A\u4E22\u5931\u3002')]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            _this9.$router.back(-1);
          }
          done();
        }
      }).then(function (action) {});
    }
  }
};